import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { AssetType, AssetTypeData, SearchAssetsState } from '@interfaces'
import { multiAssetsSearch } from '@services'
import { getAppFeatures } from '@utils/getAppFeatures'

export const clearQuery = createAction('clearQuery')

const filterByAssetType = (
  assetsSearch: SearchAssetsState,
  assetsAllowed: AssetType[],
): SearchAssetsState => {
  return Object.fromEntries(
    Object.entries(assetsSearch).filter(([key]: [AssetType, AssetTypeData]) =>
      assetsAllowed.includes(key),
    ),
  ) as SearchAssetsState
}

export const fetchAssets = createAsyncThunk<
  SearchAssetsState,
  {
    query: string
    type: 'initial' | 'search'
    origin: 'headerSearch' | 'discoverSearch'
  }
>(
  'fetchAssets',
  async (data: {
    query: string
    type: 'initial' | 'search'
    origin: 'headerSearch' | 'discoverSearch'
  }) => {
    const { query } = data
    const assetsAllowed = getAppFeatures()?.features?.assetsAllowed
    const assetsSearch = await multiAssetsSearch(query)
    return filterByAssetType(assetsSearch, assetsAllowed)
  },
)
